module.exports = "/static/assets/eaeb23f373203785501e12ece22ebe9e.png";